module.exports = __webpack_public_path__ + "static/img/bg-tr.f2afca15.png";